import { loginCode, login, detail, is_vip_login } from "@/api/gw/login.js"
export default {
  state: {
    userinfo: null,//用户信息
  },
  mutations: {
    setUserInfo(state, val) {
      state.userinfo = val
    }
  },
  actions: {
    //账号密码登录
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          localStorage.setItem("qichengUserToken", res.data.token)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //手机号验证码登录
    loginCode({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginCode(userInfo).then(res => {
          localStorage.setItem("qichengUserToken", res.data.token)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //获取用户信息
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        detail({}).then(res => {
          commit('setUserInfo', res.data)
          resolve(res.data)
        }).catch(e => {
          commit('setUserInfo', null)
          // location.reload();
        })
      })
    },
    //退出登录
    logut({ commit }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem("qichengUserToken", null)
        commit("setUserInfo", null);
      })
    },
    //判断是否为登录状态和会员
    //获取用户信息
    isVipLogin({ commit }) {
      return new Promise((resolve, reject) => {
        is_vip_login({}).then(res => {
          resolve(res)
        })
      })
    },
  },

}



// WEBPACK FOOTER //
// ./src/store/modules/user.js